// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"y3-z"};